import type {
  PlacesAddressComponent,
  PlacesGeocodeResult,
} from 'react-places-autocomplete';

export interface ParsedAddress {
  city: string;
  state: string;
  stateCode: string;
  zip: string;
}

const CITY_TYPES = [
  'locality',
  'postal_town',
  'sublocality',
  'administrative_area_level_3',
  'administrative_area_level_2',
];

const findComponent = (
  components: PlacesAddressComponent[],
  types: string[]
): PlacesAddressComponent | undefined => {
  for (const type of types) {
    const match = components.find((component) =>
      component.types.includes(type)
    );
    if (match) return match;
  }
  return undefined;
};

export const parseAddressComponents = ({
  address_components: components,
}: PlacesGeocodeResult): ParsedAddress => {
  const state = findComponent(components, ['administrative_area_level_1']);
  return {
    city: findComponent(components, CITY_TYPES)?.long_name ?? '',
    state: state?.long_name ?? '',
    stateCode: state?.short_name ?? state?.long_name ?? '',
    zip: findComponent(components, ['postal_code'])?.long_name ?? '',
  };
};
